import { debugLog } from "./debug";
let webpSupportedCache = undefined;
export const isWebpSupported = () => {
    // Return cached result if we've already checked
    if (webpSupportedCache !== undefined) {
        return webpSupportedCache;
    }
    try {
        const canvas = document.createElement("canvas");
        webpSupportedCache =
            canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
        debugLog("adora script - isWebpSupported? - ", webpSupportedCache);
        return webpSupportedCache;
    }
    catch (_e) {
        webpSupportedCache = false;
        return false;
    }
};
